import { Pipe, PipeTransform } from "@angular/core";
import * as moment from "moment-timezone";

@Pipe({ name: "deliveryTime" })
export class DeliveryTimePipe implements PipeTransform {
    transform(value: moment.Moment, tz: string): string {
        return moment(value).utc().tz(tz).format("HH:mm");
    }
}



// WEBPACK FOOTER //
// ./src/app/ContractManagement/DeliveryTimePipe.ts